module.exports = __webpack_public_path__ + "static/media/__Time.c15004fb.svg";